var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_content)?_c('div',{staticClass:"router-view-wrapper"},[_c('div',{staticClass:"data-wrapper"},[(_vm.scenario_type == 'broadcast' || _vm.scenario_type == 'sequence')?_c('MessageContent'):_vm._e(),(_vm.scenario_type == 'conference')?_c('ConferenceMessageContent'):_vm._e(),_c('RecallParticipants'),_c('PollingOptionList')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }